export const VIEW_ROUTE_KEYWORD = 'view';
export const GROUP_CALENDAR_ROUTE_KEYWORD = 'group';
export const ADD_CALENDAR_ROUTE_KEYWORD = 'addcalendar';
export const TEAMSNAP_ROUTE_KEYWORD = 'teamsnap';
export const SCHOOLS_ROUTE_KEYWORD = 'schools';
export const BROWSE_DISCOVER_CALENDARS_ROUTE_KEYWORD = 'browseDiscoverCalendars';
export const EDIT_ROUTE_KEYWORD = 'edit';
export const ITEM_ROUTE_KEYWORD = 'item';
export const ACCOUNT_ROUTE_KEYWORD = 'account';
export const SEARCH_ROUTE_KEYWORD = 'search';
export const ADD_FROM_WEB_KEYWORD = 'addfromweb';
export const COMPOSE_ROUTE_KEYWORD = 'compose';
export const ADD_GROUP_EVENTS_ROUTE_KEYWORD = 'addGroupEvents';
export const PERSONAL_ACCOUNT_ROUTE_KEYWORD = 'personal';
